import { getCart, clearCart, getAppliedDiscount, clearAppliedDiscount } from './cart.js';

const REQUIRED_FIELDS = [
	{ name: 'checkout_name', label: 'Họ tên' },
	{ name: 'checkout_phone', label: 'Số điện thoại' },
	{ name: 'checkout_email', label: 'Email' },
	{ name: 'checkout_address', label: 'Địa chỉ' },
	{ name: 'checkout_province', label: 'Tỉnh/Thành phố' },
	{ name: 'checkout_ward', label: 'Phường/Xã' },
];

function isValidEmail(value) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

const PHONE_PATTERN = /^(0|\+84)(3[2-9]|5[25689]|7[06-9]|8[1-9]|9[0-46-9])[0-9]{7}$/;

function isValidPhone(value) {
	return PHONE_PATTERN.test(value.replace(/[\s.-]/g, ''));
}

function showError(errorEl, message) {
	errorEl.textContent = message;
	errorEl.hidden = false;
}

function clearError(errorEl) {
	errorEl.hidden = true;
	errorEl.textContent = '';
}

function selectedOptionText(select) {
	return select.options[select.selectedIndex]?.text || '';
}

// Field errors render under their own input; the form banner is reserved for cart/server errors not tied to one field.
function showFieldError(form, name, message) {
	const fieldErrorEl = form.querySelector(`[data-error-for="${name}"]`);
	if (fieldErrorEl) {
		fieldErrorEl.textContent = message;
		fieldErrorEl.hidden = false;
	}
}

function clearFieldErrors(form) {
	form.querySelectorAll('[data-error-for]').forEach((el) => {
		el.hidden = true;
		el.textContent = '';
	});
}

function validateForm(form) {
	clearFieldErrors(form);
	let isValid = true;

	REQUIRED_FIELDS.forEach(({ name, label }) => {
		if (!form.elements[name].value.trim()) {
			showFieldError(form, name, `Vui lòng nhập ${label}.`);
			isValid = false;
		}
	});

	const phone = form.elements.checkout_phone.value.trim();
	if (phone && !isValidPhone(phone)) {
		showFieldError(form, 'checkout_phone', 'Số điện thoại không hợp lệ.');
		isValid = false;
	}

	const email = form.elements.checkout_email.value.trim();
	if (email && !isValidEmail(email)) {
		showFieldError(form, 'checkout_email', 'Email không hợp lệ.');
		isValid = false;
	}

	return isValid;
}

document.addEventListener('DOMContentLoaded', () => {
	const form = document.getElementById('checkout-form');
	if (!form) {
		return;
	}

	const errorEl = document.getElementById('checkout-form-error');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		clearError(errorEl);

		if (!validateForm(form)) {
			return;
		}

		const cart = getCart();
		if (!cart.length) {
			showError(errorEl, 'Giỏ hàng của bạn đang trống.');
			return;
		}

		const paymentMethodInput = document.querySelector('input[name="payment_method"]:checked');
		const submitButton = form.querySelector('button[type="submit"]');
		const originalLabel = submitButton.textContent;
		submitButton.disabled = true;
		submitButton.textContent = 'Đang xử lý...';

		// Only { id, sku, qty } is sent — price/name/attributes are re-derived server-side, never trusted from the client (inc/order-data.php).
		const items = cart.map(({ id, sku, qty }) => ({ id, sku, qty }));
		const discount = getAppliedDiscount();

		const body = new URLSearchParams({
			action: 'vbp_place_order',
			nonce: window.vbpData.checkoutNonce,
			name: form.elements.checkout_name.value.trim(),
			phone: form.elements.checkout_phone.value.trim(),
			email: form.elements.checkout_email.value.trim(),
			address: form.elements.checkout_address.value.trim(),
			province: selectedOptionText(form.elements.checkout_province),
			ward: selectedOptionText(form.elements.checkout_ward),
			note: form.elements.checkout_note.value.trim(),
			payment_method: paymentMethodInput ? paymentMethodInput.value : 'cod',
			items: JSON.stringify(items),
			// Only the code is sent — the server re-derives the discount
			// amount itself, it never trusts one computed by the client.
			discount_code: discount ? discount.code : '',
		});

		fetch(window.vbpData.ajaxUrl, { method: 'POST', body })
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					clearCart();
					clearAppliedDiscount();
					window.location.href = `/cam-on/?order=${data.data.order_id}&key=${data.data.order_token}`;
					return;
				}
				showError(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
				submitButton.disabled = false;
				submitButton.textContent = originalLabel;
			})
			.catch(() => {
				showError(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.');
				submitButton.disabled = false;
				submitButton.textContent = originalLabel;
			});
	});
});
